import styled from 'styled-components';

export const ModalHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  & h3 {
    font-size: 18px;
    font-weight: 600;
    color: ${({ theme }) => theme.vars.palette.text.primary};
  }

  & i {
    display: flex;
    justify-content: center;
    cursor: pointer;
    width: 24px;
    height: 24px;
    align-items: center;
    font-size: 16px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.vars.palette.background.default};
    color: ${({ theme }) => theme.vars.palette.text.secondary};
    transition: opacity 0.25s ease-in-out;

    &:hover {
      opacity: 0.8;
    }
  }
`;

export const Container = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 450px;
  background-color: ${({ theme }) => theme.vars.palette.background.paper};
  border-radius: ${({ theme }) => theme.vars.shape.borderRadius};
  display: flex;
  height: 100dvh;
  max-height: 600px;
  flex-direction: column;
  gap: 1rem;
  padding: 24px;

  @media (max-width: 768px) {
    max-width: calc(100% - 40px);
    padding: 24px 16px;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  &::-webkit-scrollbar-track {
    display: none;
  }

  &::-webkit-scrollbar-thumb {
    display: none;
  }
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  &::-webkit-scrollbar {
    display: none;
  }

  &::-webkit-scrollbar-track {
    display: none;
  }

  &::-webkit-scrollbar-thumb {
    display: none;
  }
`;
